import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";

export default function PasswordInput({ testId, value, onChange, placeholder = "••••••••", className = "", ...rest }) {
  const [show, setShow] = useState(false);
  return (
    <div className="relative">
      <input
        type={show ? "text" : "password"}
        data-testid={testId}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        className={`${className} pr-10`}
        {...rest}
      />
      <button type="button" onClick={() => setShow(!show)} data-testid={`${testId}-toggle`}
        aria-label={show ? "Hide password" : "Show password"}
        className="absolute right-2.5 top-1/2 -translate-y-1/2 text-slate-500 hover:text-slate-300 transition-colors">
        {show ? <EyeOff className="h-4 w-4" /> : <Eye className="h-4 w-4" />}
      </button>
    </div>
  );
}
